import * as Sentry from "@sentry/react";
import { CUSTOMER_FREQUENTLY_ORDERED_ITEMS_URL } from "../constants/endpoints";
import axiosClient from "./axios";

class FetchCustomerFrequentlyOrderedItemsService {
  static async fetchCustomerFrequentlyOrderedItems(
    shopId: string,
    phoneNumber: string
  ) {
    const body = { shopId, phoneNumber };

    return Sentry.startSpan(
      {
        op: "http.client",
        name: "POST /admin/shop/customer/frequently-ordered-items",
      },
      async () => {
        return axiosClient.post(CUSTOMER_FREQUENTLY_ORDERED_ITEMS_URL, body);
      }
    );
  }
}

export default FetchCustomerFrequentlyOrderedItemsService;
